import React, { useState, useEffect } from 'react';
import MainLayout from '../../components/layout/MainLayout';
import HondaLoader from '../../components/common/HondaLoader';
import Swal from 'sweetalert2';
import {
  getPrendasDisponibleInformation,
  getPrendasInformation,
  storePrendas,
  uploadPrendasDocument,
  setPrendasStatus
} from '../../services/prendasService';

// ============================================================
// LISTADO DE R.N.P.A.
// El código se guarda en el backend.
// El nombre se muestra únicamente en el selector.
// ============================================================
const RNPA_OPTIONS = [
  { codigo: '01102', nombre: '25 DE MAYO' },
  { codigo: '01001', nombre: 'ADROGUE Nº 1' },
  { codigo: '01136', nombre: 'ADROGUE Nº 2' },
  { codigo: '01185', nombre: 'ADROGUE Nº 3' },
  { codigo: '01234', nombre: 'ADROGUE Nº 4' },
  { codigo: '01264', nombre: 'ADROGUE Nº 5' },
  { codigo: '01317', nombre: 'ADROGUE Nº 6' },
  { codigo: '01292', nombre: 'ALBERTI' },
  { codigo: '21001', nombre: 'ALCORTA' },
  { codigo: '04073', nombre: 'ALEJO LEDESMA' },
  { codigo: '16016', nombre: 'ALLEN' },
  { codigo: '04001', nombre: 'ALTA GRACIA Nº 1' },
  { codigo: '04067', nombre: 'ALTA GRACIA Nº 2' },
  { codigo: '05012', nombre: 'ALVEAR' },
  { codigo: '01002', nombre: 'AMERICA' },
  { codigo: '03001', nombre: 'ANDALGALA' },
  { codigo: '22001', nombre: 'AÑATUYA' },
  { codigo: '14001', nombre: 'APOSTOLES' },
  { codigo: '14016', nombre: 'ARISTOBULO DEL VALLE' },
  { codigo: '01003', nombre: 'ARRECIFES' },
  { codigo: '04002', nombre: 'ARROYITO' },
  { codigo: '21038', nombre: 'ARROYO SECO Nº 1' },
  { codigo: '21054', nombre: 'ARROYO SECO Nº 2' },
  { codigo: '21031', nombre: 'ARTEAGA' },
  { codigo: '01004', nombre: 'AVELLANEDA Nº 1' },
  { codigo: '01005', nombre: 'AVELLANEDA Nº 2' },
  { codigo: '01150', nombre: 'AVELLANEDA Nº 3' },
  { codigo: '01151', nombre: 'AVELLANEDA Nº 4' },
  { codigo: '01194', nombre: 'AVELLANEDA Nº 5' },
  { codigo: '01220', nombre: 'AVELLANEDA Nº 6' },
  { codigo: '01258', nombre: 'AVELLANEDA Nº 7' },
  { codigo: '01006', nombre: 'AYACUCHO' },
  { codigo: '01007', nombre: 'AZUL Nº 1' },
  { codigo: '01229', nombre: 'AZUL Nº 2' },
  { codigo: '01008', nombre: 'BAHIA BLANCA Nº 1' },
  { codigo: '01009', nombre: 'BAHIA BLANCA Nº 2' },
  { codigo: '01142', nombre: 'BAHIA BLANCA Nº 3' },
  { codigo: '01143', nombre: 'BAHIA BLANCA Nº 4' },
  { codigo: '01212', nombre: 'BAHIA BLANCA Nº 5' },
  { codigo: '01222', nombre: 'BAHIA BLANCA Nº 6' },
  { codigo: '01312', nombre: 'BAHIA BLANCA Nº 7' },
  { codigo: '01010', nombre: 'BALCARCE' },
  { codigo: '04085', nombre: 'BALNEARIA' },
  { codigo: '01011', nombre: 'BARADERO' },
  { codigo: '06014', nombre: 'BARRANQUERAS' },
  { codigo: '08001', nombre: 'BASAVILBASO' },
  { codigo: '04003', nombre: 'BELL VILLE Nº 1' },
  { codigo: '04083', nombre: 'BELL VILLE Nº 2' },
  { codigo: '05001', nombre: 'BELLA VISTA' },
  { codigo: '01041', nombre: 'BENITO JUAREZ' },
  { codigo: '01104', nombre: 'BERAZATEGUI Nº 1' },
  { codigo: '01173', nombre: 'BERAZATEGUI Nº 2' },
  { codigo: '01209', nombre: 'BERAZATEGUI Nº 3' },
  { codigo: '01243', nombre: 'BERAZATEGUI Nº 4' },
  { codigo: '01318', nombre: 'BERAZATEGUI Nº 5' },
  { codigo: '01249', nombre: 'BERISSO Nº 1' },
  { codigo: '01281', nombre: 'BERISSO Nº 2' },
  { codigo: '01012', nombre: 'BOLIVAR' },
  { codigo: '01013', nombre: 'BRAGADO' },
  { codigo: '01014', nombre: 'BRANDSEN' },
  { codigo: '19001', nombre: 'BUENA ESPERANZA' },
  { codigo: '02102', nombre: 'CABA N° 102' },
  { codigo: '17001', nombre: 'CAFAYATE' },
  { codigo: '20001', nombre: 'CALETA OLIVIA Nº 1' },
  { codigo: '20009', nombre: 'CALETA OLIVIA Nº 2' },
  { codigo: '01105', nombre: 'CAMPANA Nº 1' },
  { codigo: '01180', nombre: 'CAMPANA Nº 2' },
  { codigo: '01291', nombre: 'CAMPANA Nº 3' },
  { codigo: '04004', nombre: 'CANALS' },
  { codigo: '21002', nombre: 'CAÑADA DE GOMEZ Nº 1' },
  { codigo: '21062', nombre: 'CAÑADA DE GOMEZ Nº 2' },
  { codigo: '01114', nombre: 'CAÑUELAS' },
  { codigo: '01131', nombre: 'CAPILLA DEL SEÑOR' },

  { codigo: '02002', nombre: 'CAPITAL FEDERAL Nº 002' },
  { codigo: '02003', nombre: 'CAPITAL FEDERAL Nº 003' },
  { codigo: '02004', nombre: 'CAPITAL FEDERAL Nº 004' },
  { codigo: '02005', nombre: 'CAPITAL FEDERAL Nº 005' },
  { codigo: '02006', nombre: 'CAPITAL FEDERAL Nº 006' },
  { codigo: '02007', nombre: 'CAPITAL FEDERAL Nº 007' },
  { codigo: '02008', nombre: 'CAPITAL FEDERAL Nº 008' },
  { codigo: '02009', nombre: 'CAPITAL FEDERAL Nº 009' },
  { codigo: '02010', nombre: 'CAPITAL FEDERAL Nº 010' },
  { codigo: '02011', nombre: 'CAPITAL FEDERAL Nº 011' },
  { codigo: '02012', nombre: 'CAPITAL FEDERAL Nº 012' },
  { codigo: '02013', nombre: 'CAPITAL FEDERAL Nº 013' },
  { codigo: '02014', nombre: 'CAPITAL FEDERAL Nº 014' },
  { codigo: '02015', nombre: 'CAPITAL FEDERAL Nº 015' },
  { codigo: '02016', nombre: 'CAPITAL FEDERAL Nº 016' },
  { codigo: '02017', nombre: 'CAPITAL FEDERAL Nº 017' },
  { codigo: '02018', nombre: 'CAPITAL FEDERAL Nº 018' },
  { codigo: '02019', nombre: 'CAPITAL FEDERAL Nº 019' },
  { codigo: '02020', nombre: 'CAPITAL FEDERAL Nº 020' },
  { codigo: '02021', nombre: 'CAPITAL FEDERAL Nº 021' },
  { codigo: '02022', nombre: 'CAPITAL FEDERAL Nº 022' },
  { codigo: '02023', nombre: 'CAPITAL FEDERAL Nº 023' },
  { codigo: '02024', nombre: 'CAPITAL FEDERAL Nº 024' },
  { codigo: '02025', nombre: 'CAPITAL FEDERAL Nº 025' },
  { codigo: '02026', nombre: 'CAPITAL FEDERAL Nº 026' },
  { codigo: '02027', nombre: 'CAPITAL FEDERAL Nº 027' },
  { codigo: '02028', nombre: 'CAPITAL FEDERAL Nº 028' },
  { codigo: '02029', nombre: 'CAPITAL FEDERAL Nº 029' },
  { codigo: '02030', nombre: 'CAPITAL FEDERAL Nº 030' },
  { codigo: '02031', nombre: 'CAPITAL FEDERAL Nº 031' },
  { codigo: '02032', nombre: 'CAPITAL FEDERAL Nº 032' },
  { codigo: '02033', nombre: 'CAPITAL FEDERAL Nº 033' },
  { codigo: '02034', nombre: 'CAPITAL FEDERAL Nº 034' },
  { codigo: '02035', nombre: 'CAPITAL FEDERAL Nº 035' },
  { codigo: '02036', nombre: 'CAPITAL FEDERAL Nº 036' },
  { codigo: '02037', nombre: 'CAPITAL FEDERAL Nº 037' },
  { codigo: '02038', nombre: 'CAPITAL FEDERAL Nº 038' },
  { codigo: '02039', nombre: 'CAPITAL FEDERAL Nº 039' },
  { codigo: '02040', nombre: 'CAPITAL FEDERAL Nº 040' },
  { codigo: '02041', nombre: 'CAPITAL FEDERAL Nº 041' },
  { codigo: '02042', nombre: 'CAPITAL FEDERAL Nº 042' },
  { codigo: '02043', nombre: 'CAPITAL FEDERAL Nº 043' },
  { codigo: '02044', nombre: 'CAPITAL FEDERAL Nº 044' },
  { codigo: '02045', nombre: 'CAPITAL FEDERAL Nº 045' },
  { codigo: '02046', nombre: 'CAPITAL FEDERAL Nº 046' },
  { codigo: '02047', nombre: 'CAPITAL FEDERAL Nº 047' },
  { codigo: '02048', nombre: 'CAPITAL FEDERAL Nº 048' },
  { codigo: '02049', nombre: 'CAPITAL FEDERAL Nº 049' },
  { codigo: '02050', nombre: 'CAPITAL FEDERAL Nº 050' },
  { codigo: '02051', nombre: 'CAPITAL FEDERAL Nº 051' },
  { codigo: '02052', nombre: 'CAPITAL FEDERAL Nº 052' },
  { codigo: '02053', nombre: 'CAPITAL FEDERAL Nº 053' },
  { codigo: '02054', nombre: 'CAPITAL FEDERAL Nº 054' },
  { codigo: '02055', nombre: 'CAPITAL FEDERAL Nº 055' },
  { codigo: '02056', nombre: 'CAPITAL FEDERAL Nº 056' },
  { codigo: '02057', nombre: 'CAPITAL FEDERAL Nº 057' },
  { codigo: '02058', nombre: 'CAPITAL FEDERAL Nº 058' },
  { codigo: '02059', nombre: 'CAPITAL FEDERAL Nº 059' },
  { codigo: '02060', nombre: 'CAPITAL FEDERAL Nº 060' },
  { codigo: '02061', nombre: 'CAPITAL FEDERAL Nº 061' },
  { codigo: '02062', nombre: 'CAPITAL FEDERAL Nº 062' },
  { codigo: '02063', nombre: 'CAPITAL FEDERAL Nº 063' },
  { codigo: '02064', nombre: 'CAPITAL FEDERAL Nº 064' },
  { codigo: '02065', nombre: 'CAPITAL FEDERAL Nº 065' },
  { codigo: '02066', nombre: 'CAPITAL FEDERAL Nº 066' },
  { codigo: '02067', nombre: 'CAPITAL FEDERAL Nº 067' },
  { codigo: '02068', nombre: 'CAPITAL FEDERAL Nº 068' },
  { codigo: '02069', nombre: 'CAPITAL FEDERAL Nº 069' },
  { codigo: '02070', nombre: 'CAPITAL FEDERAL Nº 070' },
  { codigo: '02071', nombre: 'CAPITAL FEDERAL Nº 071' },
  { codigo: '02072', nombre: 'CAPITAL FEDERAL Nº 072' },
  { codigo: '02073', nombre: 'CAPITAL FEDERAL Nº 073' },
  { codigo: '02074', nombre: 'CAPITAL FEDERAL Nº 074' },
  { codigo: '02075', nombre: 'CAPITAL FEDERAL Nº 075' },
  { codigo: '02076', nombre: 'CAPITAL FEDERAL Nº 076' },
  { codigo: '02077', nombre: 'CAPITAL FEDERAL Nº 077' },
  { codigo: '02078', nombre: 'CAPITAL FEDERAL Nº 078' },
  { codigo: '02079', nombre: 'CAPITAL FEDERAL Nº 079' },
  { codigo: '02080', nombre: 'CAPITAL FEDERAL Nº 080' },
  { codigo: '02081', nombre: 'CAPITAL FEDERAL Nº 081' },
  { codigo: '02082', nombre: 'CAPITAL FEDERAL Nº 082' },
  { codigo: '02083', nombre: 'CAPITAL FEDERAL Nº 083' },
  { codigo: '02084', nombre: 'CAPITAL FEDERAL Nº 084' },
  { codigo: '02085', nombre: 'CAPITAL FEDERAL Nº 085' },
  { codigo: '02086', nombre: 'CAPITAL FEDERAL Nº 086' },
  { codigo: '02087', nombre: 'CAPITAL FEDERAL Nº 087' },
  { codigo: '02088', nombre: 'CAPITAL FEDERAL Nº 088' },
  { codigo: '02089', nombre: 'CAPITAL FEDERAL Nº 089' },
  { codigo: '02090', nombre: 'CAPITAL FEDERAL Nº 090' },
  { codigo: '02091', nombre: 'CAPITAL FEDERAL Nº 091' },
  { codigo: '02092', nombre: 'CAPITAL FEDERAL Nº 092' },
  { codigo: '02093', nombre: 'CAPITAL FEDERAL Nº 093' },
  { codigo: '02094', nombre: 'CAPITAL FEDERAL Nº 094' },
  { codigo: '02095', nombre: 'CAPITAL FEDERAL Nº 095' },
  { codigo: '02096', nombre: 'CAPITAL FEDERAL Nº 096' },
  { codigo: '02097', nombre: 'CAPITAL FEDERAL Nº 097' },
  { codigo: '02098', nombre: 'CAPITAL FEDERAL Nº 098' },
  { codigo: '02099', nombre: 'CAPITAL FEDERAL Nº 099' },
  { codigo: '02100', nombre: 'CAPITAL FEDERAL Nº 100' },
  { codigo: '02101', nombre: 'CAPITAL FEDERAL Nº 101' },
  { codigo: '01129', nombre: 'CAPITAN SARMIENTO' },

  // ============================================================
  // PEGAR AQUÍ EL RESTO DE LOS REGISTROS DE TU LISTADO
  // ============================================================

  { codigo: '01103', nombre: 'ZARATE Nº 1' },
  { codigo: '01190', nombre: 'ZARATE Nº 2' },
  { codigo: '01278', nombre: 'ZARATE Nº 3' }
];

// Documentos requeridos/opcionales del formulario
const DOCUMENT_LIST = [
  {
    id: 'formulario03',
    label: 'FORMULARIO 03 (FRENTE)',
    optional: false
  },
  {
    id: 'cuerpoprenda',
    label: 'CUERPO DE PRENDA (FRENTE Y DORSO)',
    optional: false
  },
  {
    id: 'garantes',
    label: 'GARANTES',
    optional: true
  },
  {
    id: 'consentimiento',
    label: 'CONSENTIMIENTO CONYUGAL',
    optional: true
  },
  {
    id: 'constancia',
    label: 'CONSTANCIA DE ENTREGA',
    optional: true
  }
];

const AgregarPrenda = ({ user, onLogout, onNavigate }) => {
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);

  const [prendaBase, setPrendaBase] = useState(null);

  const [grupo, setGrupo] = useState('');
  const [orden, setOrden] = useState('');

  // Campos editables
  const [fechaInscripcion, setFechaInscripcion] = useState('');
  const [rnpa, setRnpa] = useState('');

  // Estado de documentos
  const [docs, setDocs] = useState(
    Object.fromEntries(
      DOCUMENT_LIST.map((d) => [d.id, null])
    )
  );

  // ============================================================
  // FORMATEAR FECHAS
  // Convierte:
  // DD/MM/YYYY
  // YYYY-MM-DD
  // YYYY-MM-DDTHH:mm:ss
  // a DD/MM/YYYY
  // ============================================================
  const formatDateInput = (value) => {
    if (!value) return '';

    try {
      const stringValue = String(value).trim();

      // Formato DD/MM/YYYY
      const ddMmYyyyRegex =
        /^(\d{2})\/(\d{2})\/(\d{4})/;

      const ddMmYyyyMatch =
        stringValue.match(ddMmYyyyRegex);

      if (ddMmYyyyMatch) {
        return `${ddMmYyyyMatch[1]}/${ddMmYyyyMatch[2]}/${ddMmYyyyMatch[3]}`;
      }

      // Formato YYYY-MM-DD
      const yyyyMmDdRegex =
        /^(\d{4})-(\d{2})-(\d{2})/;

      const yyyyMmDdMatch =
        stringValue.match(yyyyMmDdRegex);

      if (yyyyMmDdMatch) {
        const year = yyyyMmDdMatch[1];
        const month = yyyyMmDdMatch[2];
        const day = yyyyMmDdMatch[3];

        return `${day}/${month}/${year}`;
      }

      // Eliminar hora si viene incluida
      const fechaSinHora = stringValue
        .split('T')[0]
        .split(' ')[0];

      const numeros = fechaSinHora.replace(/\D/g, '');

      if (numeros.length >= 8) {
        return `${numeros.slice(0, 2)}/${numeros.slice(2, 4)}/${numeros.slice(4, 8)}`;
      }

      return stringValue;
    } catch {
      return '';
    }
  };

  const convertDateToSql = (date) => {
    if (!date) return '';

    const [day, month, year] = date.split('/');

    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        const saved =
          localStorage.getItem('prendaData');

        if (!saved) {
          Swal.fire({
            icon: 'warning',
            title: 'Sin datos',
            text: 'No se encontraron datos de la prenda.',
            confirmButtonColor: '#ef4444'
          });

          onNavigate('prendasDisponibles');
          return;
        }

        const casoData = JSON.parse(saved);

        const g =
          casoData.group ||
          casoData.grupo ||
          '';

        const o =
          casoData.order ||
          casoData.orden ||
          '';

        setGrupo(g);
        setOrden(o);

        if (casoData.recordDate) {
          setFechaInscripcion(
            formatDateInput(casoData.recordDate)
          );
        }

        if (casoData.registerName) {
          setRnpa(casoData.registerName);
        }

        const data =
          await getPrendasDisponibleInformation(
            g,
            o,
            user.ce_ID
          );

        setPrendaBase(data);

        if (!data?.titular) {
          Swal.fire({
            icon: 'warning',
            title: 'Campo requerido',
            text: 'La prenda no tiene titular. No avance con la operación y contacte con soporte técnico',
            confirmButtonColor: '#ef4444'
          });

          return;
        }


        // ============================================================
        // FECHA INSCRIPCIÓN
        // ============================================================
        if (data?.recordDate) {
          setFechaInscripcion(
            formatDateInput(data.recordDate)
          );
        }

        // ============================================================
        // RNPA
        // ============================================================
        if (
          data?.registerName &&
          !casoData.registerName
        ) {
          setRnpa(data.registerName);
        }

        // ============================================================
        // certificateDate
        //
        // Este dato se muestra directamente desde:
        // data.certificateDate
        //
        // Ejemplo recibido:
        // certificateDate: "10/07/2026"
        //
        // No se modifica ni se envía en storePrendas.
        // ============================================================

      } catch (err) {
        console.error(
          'Error cargando prenda disponible:',
          err
        );

        Swal.fire({
          icon: 'error',
          title: 'Error al cargar',
          text:
            err.message ||
            'No se pudieron cargar los datos de la prenda.',
          confirmButtonColor: '#ef4444'
        });
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [onNavigate]);

  const handleFechaInscripcionChange = (e) => {
    const value = e.target.value;

    let numbers = value.replace(/\D/g, '');

    numbers = numbers.slice(0, 8);

    let formattedDate = numbers;

    if (numbers.length >= 5) {
      formattedDate =
        `${numbers.slice(0, 2)}/` +
        `${numbers.slice(2, 4)}/` +
        `${numbers.slice(4, 8)}`;
    } else if (numbers.length >= 3) {
      formattedDate =
        `${numbers.slice(0, 2)}/` +
        `${numbers.slice(2)}`;
    }

    setFechaInscripcion(formattedDate);
  };

  const handleFileChange = (id, file) => {
    setDocs((prev) => ({
      ...prev,
      [id]: file
    }));
  };

  const handleGuardar = async () => {
    
    if (!fechaInscripcion.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Campo requerido',
        text: 'Ingrese la Fecha de Inscripción en el Registro.',
        confirmButtonColor: '#ef4444'
      });

      return;
    }

    const dateRegex =
      /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

    if (!dateRegex.test(fechaInscripcion)) {
      Swal.fire({
        icon: 'warning',
        title: 'Fecha inválida',
        text: 'Ingrese la fecha en formato DD/MM/YYYY.',
        confirmButtonColor: '#ef4444'
      });

      return;
    }

    if (!rnpa.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Campo requerido',
        text: 'Seleccione el R.N.P.A.',
        confirmButtonColor: '#ef4444'
      });

      return;
    }

    const requiredMissing =
      DOCUMENT_LIST.filter(
        (d) =>
          !d.optional &&
          !docs[d.id]
      );

    if (requiredMissing.length > 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Documentos requeridos',
        text: `Debe adjuntar: ${requiredMissing
          .map((d) => d.label)
          .join(', ')}`,
        confirmButtonColor: '#ef4444'
      });

      return;
    }

    try {
      setGuardando(true);

      const fechaInscripcionSql =
        convertDateToSql(fechaInscripcion);

      const payload = {
        group: grupo,
        order: orden,
        recordDate: fechaInscripcionSql,

        // Se envía únicamente el código seleccionado
        registerName: rnpa
      };

      console.log(
        'Payload enviado al backend:',
        payload
      );

      await storePrendas(payload);

      const prendaGuardada =
        await getPrendasInformation(
          grupo,
          orden
        );

      const savedId =
        prendaGuardada?.id ||
        prendaGuardada?.idPrenda;

      if (!savedId) {
        throw new Error(
          'No se obtuvo el ID de la prenda guardada. Consulte al administrador.'
        );
      }

      for (const d of DOCUMENT_LIST) {
        if (docs[d.id]) {
          await uploadPrendasDocument(
            savedId,
            d.label,
            docs[d.id]
          );
        }
      }

      await setPrendasStatus(
        parseInt(savedId, 10),
        'EN REVISION',
        '',
        parseInt(
          user?.userID ||
          user?.id ||
          0,
          10
        )
      );

      await Swal.fire({
        icon: 'success',
        title: '¡Prenda registrada!',
        text: 'La prenda fue guardada correctamente y enviada a revisión.',
        confirmButtonColor: '#ef4444',
        timer: 2500
      });

      localStorage.removeItem('prendaData');

      onNavigate('prendasDisponibles');
    } catch (err) {
      console.error(
        'Error al guardar prenda:',
        err
      );

      Swal.fire({
        icon: 'error',
        title: 'Error al guardar',
        text:
          err.message ||
          'No se pudo guardar la prenda.',
        confirmButtonColor: '#ef4444'
      });
    } finally {
      setGuardando(false);
    }
  };

  const ReadField = ({
    label,
    value,
    span2
  }) => (
    <div
      className={
        span2
          ? 'md:col-span-2'
          : ''
      }
    >
      <label className="block text-xs font-medium text-gray-500 mb-1">
        {label}
      </label>

      <input
        type="text"
        readOnly
        value={value || ''}
        className="w-full px-3 py-2 bg-gray-100 border border-gray-200 rounded-md text-sm text-gray-700 cursor-default"
      />
    </div>
  );

  if (loading) {
    return (
      <MainLayout
        user={user}
        onLogout={onLogout}
        onNavigate={onNavigate}
      >
        <div className="flex items-center justify-center h-screen">
          <HondaLoader
            message="Cargando datos de la prenda..."
            variant="fullscreen"
            size="large"
          />
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout
      user={user}
      onLogout={onLogout}
      onNavigate={onNavigate}
    >
      <div className="max-w-full mx-auto px-3 py-4">

        <div className="mb-8 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">

          <div>
            <div className="flex items-center gap-3 mb-2">

              <div className="w-1.5 h-8 gradient-red rounded-full shadow-glow-red"></div>

              <h2 className="text-2xl font-bold text-gradient">
                Agregar Prenda
              </h2>

            </div>

            <p className="text-gray-500 text-sm ml-5">
              Complete los datos para registrar la prenda
            </p>
          </div>

          <div className="text-sm font-bold text-gray-600 bg-gray-100 px-4 py-2 rounded-lg border border-gray-200 shrink-0">

            GRUPO:{' '}
            <span className="text-red-600">
              {grupo}
            </span>

            &nbsp;|&nbsp;

            ORDEN:{' '}
            <span className="text-red-600">
              {orden}
            </span>

          </div>

        </div>

        {/* DATOS DE LA PRENDA */}
        <div className="mb-6 bg-white border-2 border-gray-100 rounded-2xl shadow-soft hover:shadow-xl transition-all duration-300 overflow-visible group">

          <div className="h-1.5 gradient-red group-hover:h-2 transition-all duration-300"></div>

          <div className="bg-gradient-to-br from-honda-50 to-white px-6 py-4 border-b border-gray-100">

            <h3 className="text-sm font-bold text-honda-800 uppercase tracking-wide flex items-center gap-2">

              <span className="material-icons text-honda-600">
                inventory_2
              </span>

              Datos de la Prenda

            </h3>

          </div>

          <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">

            <ReadField
              label="Nombre del Titular"
              value={prendaBase?.titular}
              span2
            />

            <ReadField
              label="DNI / CUIT"
              value={
                prendaBase?.ident ||
                prendaBase?.documentNumber
              }
              span2
            />

            <ReadField
              label="Chasis"
              value={
                prendaBase?.vehiculeSerial ||
                prendaBase?.chasis
              }
            />

            {/* ========================================================
                FECHA LIQUIDACIÓN DEL CERTIFICADO

                El dato viene directamente del endpoint:
                certificateDate

                Ejemplo:
                certificateDate: "10/07/2026"
               ======================================================== */}
            <ReadField
              label="Fecha Liquidación del Certificado"
              value={formatDateInput(
                prendaBase?.certificateDate
              )}
            />

            {/* Fecha Inscripción Registro + RNPA */}
            <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4">

              {/* Fecha Inscripción Registro */}
              <div>

                <label className="block text-xs font-medium text-gray-500 mb-1">

                  Fecha Inscripción Registro{' '}

                  <span className="text-red-500">
                    *
                  </span>

                </label>

                <input
                  type="text"
                  placeholder="DD/MM/YYYY"
                  value={fechaInscripcion}
                  onChange={
                    handleFechaInscripcionChange
                  }
                  maxLength={10}
                  inputMode="numeric"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-md text-sm text-gray-800 focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500 transition-all duration-200"
                />

              </div>

              {/* ========================================================
                  RNPA - SELECCIONABLE

                  Se mantiene el select nativo.
                  El overflow del contenedor se deja visible para que
                  el navegador pueda mostrar el menú hacia abajo.
                 ======================================================== */}
              <div className="relative">

                <label className="block text-xs font-medium text-gray-500 mb-1">
                  R.N.P.A{' '}
                  <span className="text-red-500">
                    *
                  </span>
                </label>

                <select
                  value={rnpa}
                  onChange={(e) => setRnpa(e.target.value)}
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-md text-sm text-gray-800 focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500 transition-all duration-200"
                >
                  <option value="">
                    Seleccione un R.N.P.A.
                  </option>

                  {RNPA_OPTIONS.map((item) => (
                    <option
                      key={item.codigo}
                      value={item.codigo}
                    >
                      {item.codigo} - {item.nombre}
                    </option>
                  ))}
                </select>

              </div>
            </div>

          </div>

        </div>

        {/* GARANTES */}
        {Array.isArray(
          prendaBase?.warrantors
        ) &&
          prendaBase.warrantors.length > 0 && (

            <div className="mb-6 bg-white border-2 border-gray-100 rounded-2xl shadow-soft hover:shadow-xl transition-all duration-300 overflow-hidden group">

              <div className="h-1.5 gradient-red group-hover:h-2 transition-all duration-300"></div>

              <div className="bg-gradient-to-br from-honda-50 to-white px-6 py-4 border-b border-gray-100">

                <h3 className="text-sm font-bold text-honda-800 uppercase tracking-wide flex items-center gap-2">

                  <span className="material-icons text-honda-600">
                    shield
                  </span>

                  Datos de Garantes

                </h3>

              </div>

              <div className="overflow-x-auto">

                <table className="min-w-full divide-y divide-gray-100">

                  <thead className="bg-gray-50">

                    <tr>

                      <th className="px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase tracking-wider">
                        Nombre
                      </th>

                      <th className="px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase tracking-wider">
                        CUIL
                      </th>

                      <th className="px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase tracking-wider">
                        Género
                      </th>

                    </tr>

                  </thead>

                  <tbody className="divide-y divide-gray-100 bg-white">

                    {prendaBase.warrantors.map(
                      (g, i) => (

                        <tr
                          key={i}
                          className="hover:bg-gray-50 transition-colors"
                        >

                          <td className="px-6 py-3 text-sm text-gray-800">
                            {g.name ||
                              g.completeName ||
                              'N/A'}
                          </td>

                          <td className="px-6 py-3 text-sm text-gray-700 font-mono">
                            {g.cuil ||
                              g.documentNumber ||
                              'N/A'}
                          </td>

                          <td className="px-6 py-3 text-sm text-gray-700">
                            {g.gender ||
                              g.genero ||
                              'N/A'}
                          </td>

                        </tr>

                      )
                    )}

                  </tbody>

                </table>

              </div>

            </div>

          )}

        {/* DOCUMENTACIÓN RESPALDATORIA */}
        <div className="mb-6 bg-white border-2 border-gray-100 rounded-2xl shadow-soft hover:shadow-xl transition-all duration-300 overflow-hidden group">

          <div className="h-1.5 gradient-red group-hover:h-2 transition-all duration-300"></div>

          <div className="bg-gradient-to-br from-honda-50 to-white px-6 py-4 border-b border-gray-100">

            <h3 className="text-sm font-bold text-honda-800 uppercase tracking-wide flex items-center gap-2">

              <span className="material-icons text-honda-600">
                upload_file
              </span>

              DOCUMENTACIÓN RESPALDATORIA

            </h3>

          </div>

          <div className="p-6">

            <div className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-100 rounded-xl p-5">

              <div className="space-y-4">

                {DOCUMENT_LIST.map(
                  (doc) => (

                    <div key={doc.id}>

                      <label className="block text-sm font-medium text-gray-700 mb-2">

                        {doc.label}

                        {doc.optional && (
                          <span className="ml-2 text-xs font-normal text-gray-400">
                            (OPCIONAL)
                          </span>
                        )}

                        {!doc.optional && (
                          <span className="ml-1 text-red-500">
                            *
                          </span>
                        )}

                      </label>

                      <div className="relative">

                        <input
                          type="file"
                          id={`file-${doc.id}`}
                          className="hidden"
                          accept=".pdf"
                          onChange={(e) =>
                            handleFileChange(
                              doc.id,
                              e.target.files?.[0] ||
                              null
                            )
                          }
                        />

                        <label
                          htmlFor={`file-${doc.id}`}
                          className={`flex items-center justify-between w-full px-4 py-3 border-2 border-dashed rounded-lg cursor-pointer transition-all duration-200 ${docs[doc.id]
                              ? 'bg-green-50 border-green-300 hover:bg-green-100'
                              : 'bg-gray-50 border-gray-300 hover:bg-gray-100 hover:border-honda-400'
                            }`}
                        >

                          <div className="flex items-center gap-2 flex-1 min-w-0">

                            <span
                              className={`material-icons text-xl ${docs[doc.id]
                                  ? 'text-green-600'
                                  : 'text-gray-400'
                                }`}
                            >
                              {docs[doc.id]
                                ? 'check_circle'
                                : 'cloud_upload'}
                            </span>

                            <span className="text-sm text-gray-600 truncate">

                              {docs[doc.id]
                                ? docs[doc.id].name
                                : 'No file selected.'}

                            </span>

                          </div>

                          {docs[doc.id] && (

                            <button
                              type="button"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                handleFileChange(
                                  doc.id,
                                  null
                                );
                              }}
                              className="ml-2 text-red-500 hover:text-red-700 transition-colors"
                            >

                              <span className="material-icons text-sm">
                                close
                              </span>

                            </button>

                          )}

                        </label>

                      </div>

                    </div>

                  )
                )}

              </div>

            </div>

          </div>

        </div>

        {/* Botones */}
        <div className="flex flex-wrap gap-3 justify-end pt-2">

          <button
            onClick={() =>
              onNavigate('back')
            }
            className="px-6 py-2.5 bg-white hover:bg-gray-50 text-gray-700 rounded-xl transition-all duration-300 font-semibold border-2 border-gray-200 hover:border-gray-300 shadow-soft hover:shadow-lg hover:-translate-y-0.5 transform flex items-center gap-2"
          >

            <span className="material-icons text-base">
              arrow_back
            </span>

            Volver

          </button>

          <button
            onClick={handleGuardar}
            disabled={guardando}
            className="px-6 py-2.5 gradient-red hover:shadow-glow-red text-white rounded-xl transition-all duration-300 font-semibold shadow-soft hover:scale-105 transform disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center gap-2"
          >

            {guardando ? (
              <>
                <span className="material-icons text-base animate-spin">
                  refresh
                </span>

                Guardando...
              </>
            ) : (
              <>
                <span className="material-icons text-base">
                  send
                </span>

                Enviar Prenda
              </>
            )}

          </button>

        </div>

      </div>
    </MainLayout>
  );
};

export default AgregarPrenda;
